import type { ReactNode } from 'react';
import { SkeletonBox } from '@practium/ui';
import styles from './StatCard.module.css';

export type StatCardVariant = 'pending' | 'done' | 'upcoming' | 'note';

export interface StatCardProps {
	title: string;
	value: number;
	label: string;
	icon: ReactNode;
	variant: StatCardVariant;
	isLoading?: boolean;
}

export const StatCard = ({
	title,
	value,
	label,
	icon,
	variant,
	isLoading = false,
}: StatCardProps) => {
	return (
		<div className={styles.card} data-variant={variant}>
			<span className={styles.title}>{title}</span>
			<div className={styles.body}>
				{isLoading ? (
					<SkeletonBox width="3rem" height="2.6rem" borderRadius="0.5rem" />
				) : (
					<span className={styles.value}>{value}</span>
				)}
				<div className={styles.iconWrapper}>{icon}</div>
			</div>
			<span className={styles.label}>{label}</span>
		</div>
	);
};
